import { render, staticRenderFns } from "./DashboardReferFriend.vue?vue&type=template&id=b0475d5e&scoped=true"
import script from "./DashboardReferFriend.vue?vue&type=script&lang=ts"
export * from "./DashboardReferFriend.vue?vue&type=script&lang=ts"
import style0 from "./DashboardReferFriend.vue?vue&type=style&index=0&id=b0475d5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0475d5e",
  null
  
)

export default component.exports